export class DuplicateLocationName extends Error {
  constructor() {
    super('A location with this name already exists.')
    Object.setPrototypeOf(this, DuplicateLocationName.prototype)
  }
}
